import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { items } from '../../constants/content';
import { baseUrl, URLs } from '../../constants/urls';
import GetLink from '../../helpers/getLink/getLink';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import { helpData } from '../content/HelpData';
import Search from '../search/search';
import Tile from '../tile/tile';
import Title from '../title/Title';
import './ItemDetails.css';


export interface IItemDetailsProps {
  location: any;
  history: any;
  match: any;
}

export interface IItemDetailsState {
  subItem: any;
  breadcrumbItems: Array<any>;
  itemHelpData: any;
  invalidData: boolean;
}

class ItemDetails extends React.Component<IItemDetailsProps, IItemDetailsState> {

  public static getDerivedStateFromProps(props: IItemDetailsProps, state: IItemDetailsState) {
    const itemHierarchy = props.match.params.subItemIds.split('-');
    let subItem: any;
    subItem = items;
    let itemHelpData = helpData;
    const breadcrumbItems: Array<any> = [];
    itemHierarchy.forEach((element: string, index: number) => {
      itemHelpData = ((itemHelpData && itemHelpData instanceof Object && itemHelpData[element]) || "");
      subItem = subItem && ((subItem.subItems && subItem.subItems) || subItem).filter((i: any) => i.id === Number(element))[0];
      if (subItem && subItem.caption) {
        breadcrumbItems.push({ caption: subItem.caption, url: URLs.itemDetails.replace(":subItemIds", itemHierarchy.slice(0, index + 1).join("-")) })
      }
    });
    if (subItem && subItem.caption) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return { subItem, breadcrumbItems, itemHelpData, invalidData: false };
    }
    props.history.push(baseUrl);
    return { ...state, invalidData: true };
  }

  constructor(props: IItemDetailsProps) {
    super(props);
    this.state = {
      breadcrumbItems: [],
      invalidData: false,
      itemHelpData: {},
      subItem: {}
    }
  }

  public render() {
    return this.state.invalidData ? null : (<Col xs="12">
      <Breadcrumbs items={this.state.breadcrumbItems} redirect={this.redirect} />
      {true && <Row>
        <Col xs={{ size: 10, offset: 1 }} className="pt-2">
        <Search />
          <Title title={this.state.subItem.caption} />
          {this.state.itemHelpData && this.state.itemHelpData.preContent && <Row className="tile-container">
            <Col xs="12">
              <div className="topic-content" onClick={this.onClick} dangerouslySetInnerHTML={{ __html: this.state.itemHelpData.preContent }} />
            </Col>
          </Row>}
          {this.state.subItem.subItems && <><Row className="tile-container">
            {this.state.subItem.subItems.map((item: any) => {
              return <Tile key={item.id} iconName={item.iconName} caption={item.caption} onClick={this.selectItem} item={item} />
            })}
          </Row></>}
          {this.state.itemHelpData && this.state.itemHelpData.postContent && <Row className="tile-container">
            <Col xs="12">
              <div className="topic-content" onClick={this.onClick} dangerouslySetInnerHTML={{ __html: this.state.itemHelpData.postContent }} />
            </Col>

          </Row>}
        </Col>
      </Row>}
    </Col>);
  }
  private redirect = (url = baseUrl) => {
    this.props.history.push(url);
  }
  private selectItem = (item: any) => {
    this.props.history.push(URLs.itemDetails.replace(":subItemIds", this.props.match.params.subItemIds) + "-" + item.id);
  }
  private onClick = (event: any) => {
    if(event.target.getAttribute('data-link')) {
      const itemArray = GetLink.getLinkForItem(items, event.target.getAttribute('data-link'));
      if(itemArray.length) {
        let detailLink = "";
        itemArray.map((i:any)=>{
          detailLink += i.id + "-";
          return true;
        });
        detailLink = detailLink.substr(0, detailLink.length-1);
        this.props.history.push(URLs.itemDetails.replace(":subItemIds", detailLink));
      }
    }
  }
}

export default ItemDetails;


// WEBPACK FOOTER //
// ./src/components/itemDetails/ItemDetails.tsx